// project import
import catalogue from './catalogue';
import healthContent from './health-content';
import account from './account';
import reports from './reports';

// types
import { NavItemType } from 'types';
import assetsManagement from './assets_management';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
    items: [healthContent, catalogue, reports, account, assetsManagement]
};

export default menuItems;
